import React  from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token } = useSelector(state => state.auth)
	const location = useLocation()
	
	const publicAccessRoutes = ['/', '/patient-checkin', '/patient-intake']
	const isPublicAccessRoute = publicAccessRoutes.includes(location.pathname)
	const isTokenRoute = /^\/(contract\/sign|pay|onboard|portal)\//.test(location.pathname)
  
	return token && !isPublicAccessRoute && !isTokenRoute ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet/>
}

export default PublicRoute